import { useQuery } from '@tanstack/react-query';

import { getEnvironmentQuery } from '../queries/environments';

export const useEnvironment = (
  { projectKey, environmentKey }: { projectKey: string; environmentKey: string },
  options?: { enabled?: boolean },
) =>
  useQuery({
    ...getEnvironmentQuery({ projectKey, environmentKey }),
    ...options,
  });
